import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiAccreditationMatrix extends ApiRequestor {
  async $get(competitionId, limit = 25, offset = 0) {
    return this.$http('GET', `/competitions/${competitionId}/accreditationMatrix`)
  }
}
